/**
 * Phase 46 (Plan 46-07) — TanStack useInfiniteQuery for the admin audit page.
 *
 * Cursor-based pagination (50 rows per page) — `getNextPageParam` pulls the
 * `encoded` cursor string from the previous page's `nextCursor`. Returns
 * null when the audit log end is reached.
 */
import { useInfiniteQuery } from '@tanstack/react-query';
import {
  fetchNotificationDispatchAudit,
  type AuditListFilters,
  type AuditListResponse,
} from '../services/api/notificationAudit';

export function useNotificationDispatchAudit(filters: AuditListFilters) {
  return useInfiniteQuery<AuditListResponse, Error>({
    queryKey: ['notificationDispatchAudit', filters],
    queryFn: ({ pageParam }) =>
      fetchNotificationDispatchAudit(filters, pageParam as string | null),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.nextCursor?.encoded ?? null,
  });
}
